
import PageLayout from "@/layouts/PageLayout";
import { BackgroundGradient } from "@/components/ui/background-gradient";

const TermsPage = () => {
  return (
    <PageLayout>
      <BackgroundGradient className="py-16 px-6 flex-grow" variant="subtle">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-display font-medium mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground">
              Last Updated: June 1, 2025
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Agreement to Terms</h2>
            <p>
              These Terms of Service govern your use of the cheqbooq website and services 
              (the "Service"). By using our Service, you agree to be bound by these Terms. If you disagree with 
              any part of the terms, you do not have permission to access the Service.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Pre-Launch Pledges</h2>
            <p>
              By making a pledge to support cheqbooq before our official launch:
            </p>
            <ul>
              <li>
                You understand that your pledge represents a commitment to support the development of the cheqbooq platform.
              </li>
              <li>
                Your payment will be processed at the time of pledge. Refunds may be considered on a case-by-case basis 
                before our official launch.
              </li>
              <li>
                The benefits associated with your pledge tier will be provided upon our official launch, currently 
                targeted for December 2025, subject to development progress.
              </li>
              <li>
                You acknowledge that the cheqbooq service is currently under development and that features, 
                functionality, and launch timing may change.
              </li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Service Description</h2>
            <p>
              cheqbooq is developing a financial data platform that aims to provide users with insights and control over their 
              financial information. Upon launch, we plan to offer:
            </p>
            <ul>
              <li>Financial data analysis and visualization tools</li>
              <li>Personal financial insights and recommendations</li>
              <li>Tools to help understand spending patterns and behaviors</li>
            </ul>
            <p>
              All features are subject to development progress and may change before launch.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">User Responsibilities</h2>
            <p>
              You are responsible for:
            </p>
            <ul>
              <li>Maintaining the confidentiality of your account information</li>
              <li>Providing accurate and complete information</li>
              <li>Complying with all applicable laws and regulations</li>
              <li>Using the Service in a manner consistent with these Terms and our Privacy Policy</li>
            </ul>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Intellectual Property</h2>
            <p>
              The Service and its content, features, and functionality are owned by cheqbooq and are 
              protected by copyright, trademark, and other intellectual property laws.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by applicable law, cheqbooq, its directors, employees, and affiliates 
              shall not be liable for any indirect, incidental, special, consequential or punitive damages, including 
              without limitation, loss of profits, data, use, or other intangible losses, resulting from your use of 
              or inability to use the Service.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Changes to Terms</h2>
            <p>
              We reserve the right to modify or replace these Terms at any time. We will provide notice of 
              material changes by posting the new Terms on this page and updating the "Last Updated" date.
            </p>
            
            <h2 className="text-2xl font-display font-medium mt-12 mb-4">Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us at legal@cheqbooq.com.
            </p>
          </div>
        </div>
      </BackgroundGradient>
    </PageLayout>
  );
};

export default TermsPage;
